import { RootState } from 'typesafe-actions';
import { createSelector } from 'reselect';

export const getAllCookies = (state: RootState) => state.cookieParsed?.cookies || {};

export const getIsAuthorized = createSelector(getAllCookies, (cookie) => {
  return cookie['user-auth'] === 'true';
});
